import { render, staticRenderFns } from "./TrademarkSearch.vue?vue&type=template&id=1554c93a&"
import script from "./TrademarkSearch.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports